// extracted by mini-css-extract-plugin
export default {"productGallery":"dK-z","inQuickShop":"eK-z"};